const PrivacyPolicy = () => {

    return (
        <iframe src="/privacy.html" title="Terms and Conditions" width="100%" height="800px"/>
    );
}

export default PrivacyPolicy;